import React from "react";
import "./GifModal.css";

interface GifModalProps {
  open: boolean;
  videoSrc: string;
  onViewWebsite: () => void;
}

const GifModal: React.FC<GifModalProps> = ({
  open,
  videoSrc,
  onViewWebsite,
}) => {
  if (!open) return null;

  return (
    <div className="gif-modal-backdrop">
      <div className="gif-modal">
        <div className="gif-modal-video-wrapper">
          <video
            src={videoSrc}
            autoPlay
            loop
            muted
            playsInline
            className="gif-modal-video"
          />
        </div>
        <p>Welcome to Chantal Ekabe Ministries</p>
        <button className="gif-modal-btn" onClick={onViewWebsite}>
          Click To Enter{" "}
        </button>
      </div>
    </div>
  );
};

export default GifModal;
